import request from '@/utils/request'

// 获取对练机器人列表
export const getExerciseList = (params) => {
  return request.post('/prompt/list', params)
}
// 获取角色列表
export const roleOptions = () => {
  return request.post('/prompt/role/options')
}
// 获取故事列表
export const storyOptions = () => {
  return request.post('/prompt/story/options')
}
// 获取详情
export const getExerciseDetail = (params) => {
  return request.get(`/prompt/get/${params.id}`)
}
// 更新详情
export const updateExerciseDetail = (params) => {
  return request.post(`/prompt/upsert`, params)
}

// 故事列表查询
export const storyList = (params) => {
  return request.post(`/story/page`, params)
}
// 新增故事
export const storyAdd = (params) => {
  return request.post(`/story/add`, params)
}
// 更新故事
export const storyUpdate = (params) => {
  return request.post(`/story/upd`, params)
}
// 查询问题列表
export const queryQA = (params) => {
  return request.post(`/storyqa/page`, params)
}
// 新增问题
export const qaAdd = (params) => {
  return request.post(`/storyqa/add`, params)
}
// 更新问题
export const qaUpdate = (params) => {
  return request.post(`/storyqa/upd`, params)
}
// 删除问题
export const qaDel = (params) => { return request.post(`/storyqa/delete/${params.id}`) }
// 查询任务资源列表
export const sourceTaskList = (params) => { return request.post(`/source/task/list`, params) }
// 查询问题列表
export const sourceQuestionList = (params) => { return request.post(`/source/question/list`, params) }
// 模板列表（分页）
export const templateList = (params) => { return request.post(`/template/page`, params) }
// 模板列表（不分页）
export const templateAllList = (params) => { return request.post(`/template/list`, params) }
// 新增模板
export const templateAdd = (params) => { return request.post(`/template/add`, params) }
// 更新模板
export const templateUpdate = (params) => { return request.post(`/template/upd`, params) }
// 删除模板
export const templateDel = (params) => { return request.post(`/template/delete/${params.id}`) }
// 批量新增问题
export const storyqaBatchAdd = (params) => { return request.post(`/storyqa/batchAdd`, params) }
// 文件转换
export const fileText = (formData) => {
  return request.post(`/story/file/text`, formData)
}
// 保存故事
export const saveStory = (params) => {
  return request.post(`/story/identify`, params)
}
// 故事详情
export const storyDetail = (params) => {
  return request.post(`/story/get/${params.id}`)
}
// 更新故事
export const updateStory = (params) => {
  return request.post(`/story/update`, params)
}
// 删除故事
export const delStory = (params) => {
  return request.post(`/story/delete/${params.id}`)
}
// 查询任务列表
export const getTaskList = (params) => {
  return request.post(`/task_base/list`, params)
}
// 查询任务详情
export const getTaskDetail = (id) => {
  return request.post(`/task_base/get/${id}`)
}
// 故事保存
export const storySave = (params) => {
  return request.post(`/story/save`, params)
}
// 查询故事分类
export const getStoryType = () => {
  return request.post(`/story/story-type/options`)
}
